var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-wrapper", class: _vm.classObj },
    [
      _vm.device === "mobile" && _vm.sidebar.opened
        ? _c("div", {
            staticClass: "drawer-bg",
            on: { click: _vm.handleClickOutside },
          })
        : _vm._e(),
      _c(
        "el-header",
        { staticStyle: { "margin-bottom": "2px", height: "56px" } },
        [
          _c(
            "div",
            { class: { "fixed-header": _vm.fixedHeader } },
            [_c("navbar")],
            1
          ),
        ]
      ),
      _c("sidebar", { staticClass: "sidebar-container" }),
      _c("div", { staticClass: "main-container" }, [_c("app-main")], 1),
      _c("ReviewResultModal", { ref: "reviewResultModal" }),
      _c("modify-login-pwd-modal", { ref: "loginPwdModalRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }